{
  "title": "Fizban's Platinum Shield",
  "source": "Fizban's Treasury of Dragons",
  "levelAndSchool": "6th-level abjuration",
  "level": 6,
  "castingTime": "1 bonus action",
  "range": "60 feet",
  "components": "V, S, M (a platinum-plated dragon scale, worth at least 500 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create a field of silvery light that surrounds a creature of your choice within range (you can choose yourself). The field sheds dim light out to 5 feet. While surrounded by the field, a creature gains the following benefits:",
    "Cover. The creature has half cover.",
    "Damage Resistance. The creature has resistance to acid, cold, fire, lightning, and poison damage.",
    "Evasion. If the creature is subjected to an effect that allows it to make a Dexterity saving throw to take only half damage, the creature instead takes no damage if it succeeds on the saving throw, and only half damage if it fails.",
    "As a bonus action on subsequent turns, you can move the field to another creature within 60 feet of the field."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
